import { useEffect, useState } from 'react'

import { uniq } from 'lodash'

import { MUI, StandardPageStructure, TemporaryPassword } from 'components'
import FeedbackItem from './components/FeedbackItem'

import { useNavigate } from 'react-router-dom'
import { useAuth } from 'hooks'

import service from 'service'

import privacyChannelConfigurationSteps, {
  PrivacyChannelConfigurationStepsType,
} from 'constants/privacyChannelConfigurationSteps'

const InstallFeedback = () => {
  const navigate = useNavigate()
  const [showTemporaryPassword, setShowTemporaryPassword] = useState(false)

  const { user, userCompany, companyMaturity, loadCompanyMaturity } = useAuth()

  const installSteps = [
    'Escaneamos o seu site',
    'Geramos o seu banner de cookies',
    'Instalamos o banner no seu site',
    'Instalamos seu selo de privacidade',
    'Geramos suas políticas',
    'Geramos seu canal de atendimento a titulares',
  ]

  const [stepState, setStepState] = useState<string[]>(
    companyMaturity?.privacyChannelConfigured ? installSteps : [installSteps[0]]
  )

  const stepsLoading = stepState.length < installSteps.length

  const goHome = () => navigate('/')
  const chargeSteps = () => {
    const itemStep = installSteps[stepState.length]
    if (stepsLoading && itemStep) {
      setStepState([...stepState, itemStep])
    }
  }

  const handleShowTemporaryPassword = () => setShowTemporaryPassword(true)

  useEffect(() => {
    if (stepsLoading) {
      setTimeout(chargeSteps, 1000)
    }

    //eslint-disable-next-line
  }, [stepsLoading, stepState])

  const mountConfigurationData = (
    data: PrivacyChannelConfigurationStepsType
  ) => ({
    configurations: {
      dataTreatments: data?.dataTreatments,
      dataShares: data?.dataShare,
      dataUpdate: { ...data?.dataUpdate, active: true },
      DataDestroy: { ...data?.dataDestroy, active: true },
    },
  })

  useEffect(() => {
    if (!userCompany?.company?.hasTrayStore) {
      return goHome()
    }

    if (!companyMaturity?.privacyChannelConfigured) {
      service.dponet.answerOptionTicket
        .configure({
          data: mountConfigurationData(
            privacyChannelConfigurationSteps.TEMPLATE_TRAY
          ),
        })
        .then(() => loadCompanyMaturity())
    }

    //eslint-disable-next-line
  }, [])

  if (showTemporaryPassword) {
    return <TemporaryPassword />
  }

  return (
    <StandardPageStructure
      display="flex"
      width="100%"
      height="100%"
      alignItems="center"
      justifyContent="center"
    >
      <MUI.Box height="70vh" width="100%">
        <MUI.Grid container spacing={8} justifyContent="center">
          {uniq(stepState).map((step, index) => (
            <FeedbackItem
              key={step}
              step={step}
              concluded={stepState.length - 1 > index || !stepsLoading}
            />
          ))}
          {!stepsLoading && (
            <MUI.Grid item lg={7} md={8} xs={12}>
              <MUI.Box display="flex" justifyContent="end" gap={4}>
                <MUI.Button
                  variant="contained"
                  color="primary"
                  onClick={goHome}
                >
                  Ir para o início
                </MUI.Button>
                {user?.temporaryPassword && (
                  <MUI.Button
                    onClick={handleShowTemporaryPassword}
                    variant="contained"
                    color="tertiary"
                  >
                    Cadastrar senha
                  </MUI.Button>
                )}
              </MUI.Box>
            </MUI.Grid>
          )}
        </MUI.Grid>
      </MUI.Box>
    </StandardPageStructure>
  )
}

export default InstallFeedback
